import en from '@/i18n/translations/en.translations';
import es from '@/i18n/translations/es.translations';

const messages = {
  en,
  es,
};

export default messages;
